import { MarkovGroupState } from "server/models"
import { GET, DELETE, POST } from "client/store/utils"
import { MarkovGroupStateList } from "./types"


export const LoadAllMarkovGroupStates = (modelId: number) => (
    GET(`/markovGroupState/modelId/${modelId}`)
    .then((rows: MarkovGroupState[]) => {
        const groupStateList: MarkovGroupStateList = {}
        rows.forEach((row) => {
            if (!groupStateList[row.groupId]) groupStateList[row.groupId] = []
            groupStateList[row.groupId].push(row.stateId)
        })
        return groupStateList
    })
)

export const LoadMarkovGroupStates = (modelId: number, groupId: number) => (
    GET(`/markovGroupState/groupStates/modelId/${modelId}/groupId/${groupId}`)
    .then((rows: MarkovGroupState[]) => {
        const stateIds: number[] = []
        rows.forEach((row) => {
            stateIds.push(row.stateId)
        })
        return stateIds
    })
)

export const AddMarkovGroupStates = (data: MarkovGroupState[]) => (
    POST(
        "/markovGroupState/add",
        JSON.stringify(data),
    )
)

export const DeleteMarkovGroupState = (
    modelId: number,
    groupId: number,
    stateId: number,
) => (
    DELETE(`/markovGroupState/delete/${modelId}/${groupId}/${stateId}`)
    .then((removedRows: number) => removedRows)
)
